import { FSA } from 'flux-standard-action';
import { ModalReducerState } from './Modal.reducer';

export enum ModalActions {
  Clear = '@ModalUi/Clear',
  Register = '@ModalUi/Register',
  Toggle = '@ModalUi/Toggle',
  UnRegister = '@ModalUi/UnRegister',
}

export interface ModalRegisterPayload {
  id: keyof ModalReducerState;
  toggle: boolean;
}

export interface ModalTogglePayload {
  id: keyof ModalReducerState;
  toggle?: boolean;
}

export const modalActions = {
  clear: (): FSA<ModalActions.Clear> => ({
    type: ModalActions.Clear
  }),
  register: (payload: ModalRegisterPayload): FSA<ModalActions.Register, ModalRegisterPayload> => ({
    type: ModalActions.Register,
    payload,
  }),
  toggle: (payload: ModalTogglePayload): FSA<ModalActions.Toggle, ModalTogglePayload> => ({
    type: ModalActions.Toggle,
    payload,
  }),
  unRegister: (payload: string): FSA<ModalActions.UnRegister, string> => ({
    type: ModalActions.UnRegister,
    payload,
  }),
}